export const catchUpHeaderLabel = "HOTx3b";
export const headlinesHeaderLabel = "YbLAW";
export const priorityViewLabel = "zljIge";
export default {catchUpHeaderLabel,headlinesHeaderLabel,priorityViewLabel};